import React, { useState } from "react";
import DatePicker from "react-datepicker";
import { Helmet } from "react-helmet";
import { AppName } from "../../../../util/app";
import FabButton from "../../../../partials/Buttons/FabButton";

const DrugChartForm = ({ onSubmit, onCancel }) => {
    const [model, setModel] = useState({
        prescriptions: [{ drugName: "", pharmacy: "", instruction: "", dose: "", frequency: "", route: "", startDate: new Date(), stopDate: new Date(), initial: "" }]
    });

    const onChange = (idx, key, value) => {
        if (key && value) {
            let _model = { ...model };
            _model.prescriptions[idx][key] = value;
            setModel(_model);
        }
    };

    return (
        <>
            <Helmet>
                <title>New Drug Chart | {AppName}</title>
            </Helmet>

            <form
                method="POST"
                onSubmit={e => {
                    e.preventDefault();
                    document.body.scrollTop = 0;
                    document.documentElement.scrollTop = 0;
                    onSubmit(model);
                }}
            >
                <div className="row">
                    {model.prescriptions.map((_, idx) => (
                        <div className="col-12">
                            <div className="card fade-in">
                                <div className="card-head">
                                    <header>New Drug Chart {idx + 1}</header>
                                </div>
                                <div className="card-body">
                                    <div className="form-row">
                                        <div className="col">
                                            <label htmlFor={"drug-name" + idx}>Drug Name *</label>
                                            <input
                                                type="text"
                                                className="form-control input-height"
                                                id={"drug-name" + idx}
                                                onChange={({ currentTarget }) => onChange(idx, "drugName", currentTarget.value)}
                                                required
                                                aria-describedby={"drug-name" + idx}
                                                placeholder="Enter drug name"
                                            />
                                        </div>

                                        <div className="col">
                                            <label htmlFor={"dose-id" + idx}>Drug Dose*</label>
                                            <input
                                                type="text"
                                                className="form-control input-height"
                                                id={"dose-id" + idx}
                                                onChange={({ currentTarget }) => onChange(idx, "dose", currentTarget.value)}
                                                required
                                                aria-describedby={"dose-id" + idx}
                                                placeholder="enter dose"
                                            />
                                        </div>
                                        <div className="col">
                                            <label htmlFor={"route-id" + idx}>Route *</label>
                                            <input
                                                type="text"
                                                className="form-control input-height"
                                                id={"route-id" + idx}
                                                onChange={({ currentTarget }) => onChange(idx, "route", currentTarget.value)}
                                                required
                                                aria-describedby={"route-id" + idx}
                                                placeholder="enter route"
                                            />
                                        </div>
                                    </div>

                                    <div className="form-row m-t-20">
                                        <div className="col">
                                            <label htmlFor={"start-date" + idx}>Start Date *</label>
                                            <DatePicker
                                                selected={_.startDate}
                                                onChange={date => {
                                                    onChange(idx, "stopDate", date);
                                                    onChange(idx, "startDate", date);
                                                }}
                                                className="form-control input-height"
                                                timeIntervals={15}
                                                dateFormat="MMM d, yyyy"
                                            />
                                        </div>
                                        <div className="col">
                                            <label htmlFor={"stop-date-id" + idx}>Stop Date *</label>
                                            <DatePicker
                                                selected={_.stopDate}
                                                onChange={date => onChange(idx, "stopDate", date)}
                                                className="form-control input-height"
                                                timeIntervals={15}
                                                dateFormat="MMM d, yyyy"
                                            />
                                        </div>
                                        <div className="col">
                                            <label htmlFor={"initial-id" + idx}>Initial*</label>
                                            <input
                                                type="text"
                                                className="form-control input-height"
                                                id={"initial-id" + idx}
                                                onChange={({ currentTarget }) => onChange(idx, "initial", currentTarget.value)}
                                                required
                                                aria-describedby={"initial-id" + idx}
                                                placeholder="enter initial"
                                            />
                                        </div>
                                    </div>

                                    <div className="form-row m-t-20">
                                        <div className="col">
                                            <label htmlFor={"pharmacy-id" + idx}>Pharmacy *</label>
                                            <textarea
                                                name={"pharmacy-id" + idx}
                                                id={"pharmacy-id" + idx}
                                                onChange={({ currentTarget }) => onChange(idx, "pharmacy", currentTarget.value)}
                                                className="form-control form-control-textarea"
                                                required
                                                rows="2"
                                                placeholder="enter pharmacy"
                                            ></textarea>
                                        </div>
                                        <div className="col">
                                            <label htmlFor={"instruction-id" + idx}>Special Instruction *</label>
                                            <textarea
                                                name={"instruction-id" + idx}
                                                id={"instruction-id" + idx}
                                                onChange={({ currentTarget }) => onChange(idx, "instruction", currentTarget.value)}
                                                className="form-control form-control-textarea"
                                                required
                                                rows="2"
                                                placeholder="enter drug instruction"
                                            ></textarea>
                                        </div>
                                    </div>
                                    <div className="form-row m-t-20">
                                        <div className="col">
                                            <label htmlFor={"frequency-id" + idx}>Drug Frequency *</label>
                                            <input
                                                type="text"
                                                className="form-control input-height"
                                                id={"frequency-id" + idx}
                                                onChange={({ currentTarget }) => onChange(idx, "frequency", currentTarget.value)}
                                                required
                                                aria-describedby={"frequency-id" + idx}
                                                placeholder="enter frequency"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}

                    <div className="col-12">
                        <div className="card">
                            <div className="card-body">
                                <div className="form-group text-center m-t-20">
                                    <button type="submit" className="mdl-button mdl-button--raised mdl-js-ripple-effect margin-right-10 m-t-20 btn-circle btn-success">
                                        Create Drug Chart
                                        <i className="material-icons">keyboard_arrow_down</i>
                                    </button>
                                    <button type="button" onClick={onCancel} className="mdl-button mdl-button--raised mdl-js-ripple-effect m-t-20 btn-circle">
                                        Cancel <i className="material-icons text-danger">close</i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <FabButton
                title="Add More Drug Chart Form"
                onClick={() => {
                    let _model = { ...model };
                    _model.prescriptions.push({
                        drugName: "",
                        pharmacy: "",
                        instruction: "",
                        dose: "",
                        frequency: "",
                        route: "",
                        startDate: new Date(),
                        stopDate: new Date(),
                        initial: ""
                    });
                    setModel(_model);
                }}
            />
        </>
    );
};
export default DrugChartForm;
